import getRequest from "./getRequest";
import putRequest from "./putRequest";

const BASE = "/part-category-groups";

/**
 * @returns {Promise<Array<{ id: string, category: { en?: string, it?: string, sq?: string } }>>}
 */
export function getPartCategoryGroups() {
  return getRequest(`${BASE}/categories`, "");
}

/**
 * @param {string} categoryId
 * @returns {Promise<Array<{ _id: string, partCode: number, title: object, enabled: boolean }>>}
 */
export function getPartsByCategoryId(categoryId) {
  return getRequest(`${BASE}/${categoryId}/parts`, "");
}

/**
 * @param {string} categoryId
 * @param {number} partCode
 * @param {boolean} enabled
 */
export function putPartEnabled(categoryId, partCode, enabled) {
  return putRequest(`${BASE}/${categoryId}/parts/enabled`, "", {
    partCode,
    enabled,
  });
}
